<template>
    <div v-if="Role === '1'">
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>芝麻信用免押金设置</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">新建版本</el-button>
                    <!-- <el-button type="info" @click="handleFresh">更新特定用户</el-button> -->
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleUser">更新特定用户</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="fetchList">
            <el-table-column prop="version" label="版本名称">
            </el-table-column>
            <el-table-column label="创建时间" inline-template :context="_self">
                <span v-if="row.created">{{row.created.split('T')[0] + ' ' + row.created.split('T')[1].split('.')[0]}}</span>
            </el-table-column>
            <el-table-column inline-template :context="_self" width="150" label="操作">
                <span>
                                              <el-button type="text" size="small" v-if="row.version !== global" @click="handleLive($index, row)">激活</el-button>
                                              <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                                              <el-button @click="handleDelete($index, row)" type="text" size="small" v-if="global && global.length && row.version !== global[0].SettingValue">删除</el-button>
                                    </span>
            </el-table-column>
        </el-table>
    
    
        <el-dialog title="新建芝麻信用版本" v-model="addVersion">
            <el-form :model="versionForm" ref="versionForm" :rules="addVersionRules" label-width="200px">
                <el-form-item label="版本名称" label-width="200px" prop="version">
                    <el-input v-model="versionForm.version" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="650-700分(单位：分)" label-width="200px" prop="one">
                    <el-input v-model="versionForm.one" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="701-750分(单位：分)" label-width="200px" prop="two">
                    <el-input v-model="versionForm.two" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="751-800分(单位：分)" label-width="200px" prop="three">
                    <el-input v-model="versionForm.three" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="801-850分(单位：分)" label-width="200px" prop="four">
                    <el-input v-model="versionForm.four" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('versionForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
        <el-dialog title="更新特定用户" :visible.sync="dialogSearch">
            <el-form :model="searchForm">
                <el-form-item label="用户手机号" label-width="150px">
                    <el-input v-model="searchForm.username" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogSearch = false">取 消</el-button>
                <el-button type="primary" @click="searhSure">确 定</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="编辑芝麻信用版本" v-model="editVersion">
            <el-form :model="editVersionForm" ref="editVersionForm" :rules="addVersionRules" label-width="120px">
                <el-form-item label="版本名称" label-width="200px" prop="version">
                    <el-input v-model="editVersionForm.version" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="650-700分(单位：分)" label-width="200px" prop="one">
                    <el-input v-model="editVersionForm.one" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="701-750分(单位：分)" label-width="200px" prop="two">
                    <el-input v-model="editVersionForm.two" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="751-800分(单位：分)" label-width="200px" prop="three">
                    <el-input v-model="editVersionForm.three" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="801-850分(单位：分)" label-width="200px" prop="four">
                    <el-input v-model="editVersionForm.four" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="editSubmit('editVersionForm')">保存</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    
    </div>
    <h3 v-else>
        暂无权限
    </h3>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        postVersions,
        putGlobalSettings,
        deleteVersions,
        patchVersions,
        patchVersionsId,
        getUsers,
        updateZM
    } from '../../api/version'
    
    export default {
        data() {
            return {
                 Role: sessionStorage.power,
                dialogSearch: false,
                searchForm: {},
                fetchList: [],
                global: [],
                addVersionRules: {
                    version: [{
                        required: true,
                        message: '请输入版本名称',
                        trigger: 'blur'
                    }],
                    one: [{
                        required: true,
                        message: '请输入600-700分的值',
                        trigger: 'blur'
                    }],
                    two: [{
                        required: true,
                        message: '请输入701-750分的值',
                        trigger: 'blur'
                    }],
                    three: [{
                        required: true,
                        message: '请输入751-800分的值',
                        trigger: 'blur'
                    }],
                    four: [{
                        required: true,
                        message: '请输入801-850分的值',
                        trigger: 'blur'
                    }]
                },
                userForm: {
                    user: '1',
                    role: ''
                },
                addVersion: false,
                editVersion: false,
                versionForm: {},
                editVersionForm: {},
                versionOption: []
            }
        },
        beforeCreate() {
            let localVersion = this.$store.state.currentIndex
            getVersions().then(data => {
                this.fetchList = data.data.filter(item => {
                    if (item.version && item.version.indexOf('zm') == 0) {
                        return item
                    }
                })
                if (localVersion.length) {
                    this.fetchList.push(localVersion)
                }
            }, err => {
                console.log(err, 'xx')
            })
    
            getGlobalSettings().then(res => {
                res.data.forEach(item => {
                    if (item.SettingKey === 'zm_line') {
                        this.global = item.SettingValue
                    }
                })
                console.log(res)
            })
    
        },
        methods: {
            searhSure() {
                if (this.searchForm.username) {
                    getUsers(sessionStorage.userId, JSON.stringify({
                        'where': {
                            'username': this.searchForm.username
                        }
                    })).then(res => {
                        if (res.data && res.data.length) {
                            updateZM(sessionStorage.userId, res.data[0].userId).then(res => {
                                if (res.data) {
                                    this.$message({
                                        message: '更新成功',
                                        type: 'success'
                                    });
                                }
                            }).catch(err => {
                                this.$message.error(err.response.data.error.message)
                            })
                        } else {
                            this.$message.error('暂无此用户')
                        }
                    }).catch(err => {
                        this.$message.error(err.response.data.error.message)
                    })
                } else {
                    this.$message.error('请输入用户手机号')
                }
    
            },
            handleUser() {
                this.dialogSearch = true
            },
            handleEdit(index, row) {
                this.editVersionForm = {
                    'version': row.version,
                    'id': row.id,
                    'one': row.value[700],
                    'two': row.value[750],
                    'three': row.value[800],
                    'four': row.value[850],
    
                }
                this.editVersion = true
            },
            handleLive(index, row) {
                console.log(row)
                let data = {
                    "SettingKey": 'zm_line',
                    "SettingValue": row.version
                }
                putGlobalSettings(sessionStorage.userId, data).then(res => {
                    console.log(res.data)
                    if (res.data.SettingKey) {
                        this.$message({
                            message: '成功激活',
                            type: 'success'
                        });
                        this.global = res.data.SettingValue
                    }
                }, err => {
                    console.log(err)
                })
            },
            handleAdd() {
                this.versionForm = {
                    version: '',
                    base: '',
                    remark: ''
                }
                this.addVersion = true
            },
            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该版本, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    console.log(row.id)
                    deleteVersions(sessionStorage.userId, row.id).then(res => {
                        console.log(res)
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.fetchList.splice(index, 1)
                    }, err => {
                        this.$message({
                            type: 'info',
                            message: '删除失败'
                        });
                    })
    
                    // this.refresh()
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleCheck(val) {},
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(this.versionForm)
                        let data = {
                            'version': this.versionForm.version,
                            'value': {
                                650: 0,
                                700: this.versionForm.one,
                                750: this.versionForm.two,
                                800: this.versionForm.three,
                                850: this.versionForm.four,
                            }
                        }
                        patchVersions(sessionStorage.userId, data).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.$message({
                                    message: '新建成功',
                                    type: 'success'
                                });
                                this.fetchList.push(data)
                                this.addVersion = false
    
                                let localVersion = this.$store.state.currentIndex
                                getVersions().then(data => {
                                    this.fetchList = data.data.filter(item => {
                                        if (item.version && item.version.indexOf('zm') == 0) {
                                            return item
                                        }
                                    })
                                    if (localVersion.length) {
                                        this.fetchList.push(localVersion)
                                    }
                                }, err => {
                                    console.log(err, 'xx')
                                })
    
                                getGlobalSettings().then(res => {
                                    res.data.forEach(item => {
                                        if (item.SettingKey === 'zm_line') {
                                            this.global = item.SettingValue
                                        }
                                    })
                                    console.log(res)
                                })
                            } else {
                                this.$message.error('新建失败')
                            }
                        })
    
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            editSubmit(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log(this.editVersionForm)
                        let data = {
                            'version': this.editVersionForm.version,
                            'value': {
                                650: 0,
                                700: this.editVersionForm.one,
                                750: this.editVersionForm.two,
                                800: this.editVersionForm.three,
                                850: this.editVersionForm.four,
                            }
                        }
                        patchVersionsId(sessionStorage.userId, this.editVersionForm.id, data).then(res => {
                            console.log(res.data)
                            if (res.data) {
                                this.$message({
                                    message: '更新成功',
                                    type: 'success'
                                });
                                this.fetchList.forEach((item, index) => {
                                    if (item.id === this.editVersionForm.id) {
                                        this.fetchList[index] = data
                                    }
                                })
                                this.editVersion = false
                            } else {
                                this.$message.error('更新失败')
                            }
                        })
    
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ZmSetting.vue?6805b106